import React, { useRef, useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import Section from '../components/dashboard/section'
import Franchises from '../components/dashboard/franchises'
import trip_home_icon from '../assets/image/web-icons/home.png'
import './../css/main.css'
import { history } from '../functions/_helpers'
import {FiSearch} from 'react-icons/fi'
import jwt from 'jwt-decode'
import {franchiseService} from '../functions/services'

function Index() {
   const addBtns = useRef(null);
   const searchIcon = useRef(null);


   const [franchises, setFranchises] = useState([]);
   const [filteredFranchises, setFilteredFranchises] = useState([]);
   const [searchString, setSearchString] = useState('');
   const franchisesRef = useRef();
   const filteredFranchisesRef = useRef();

   franchisesRef.current = franchises;
   filteredFranchisesRef.current = filteredFranchises;

/* Check access rights. Only admin (1) is allowed */
   let user_data = JSON.parse(localStorage.getItem('user'))==null ?  [] : JSON.parse(localStorage.getItem('user'));
   if(user_data === null || user_data.length === 0)
   {
      localStorage.clear();
      history.push('/login');
   }

    // Check Role
   const decodedToken = jwt(user_data.token);
   if (decodedToken == null || decodedToken == undefined) {
         localStorage.clear();
         history.push('/login');
   }
   const role = parseInt(decodedToken.role);
   if(role !== 1){
      history.push('/');
   }

   useEffect(() => {
      const fetchData = async () => {
         await franchiseService.getFranchises()
         .then((response)=>{
            setFranchises(response);
            setFilteredFranchises(response);
         }).catch((error)=>{
            console.log(error.message);
         });
      };

      fetchData();
   }, []);


   const handleSearch= (e) => {
      const { name, value } = e.target;
      setSearchString(value);
      filterFranchises(franchises, value);
   }

   const filterFranchises = (array, filter) => {
      setFilteredFranchises(array.filter(franchise =>
         (franchise.name != null && franchise.name.toLowerCase().indexOf(filter) >= 0) ||
         (franchise.email != null && franchise.email.toLowerCase().indexOf(filter) >= 0) ||
         (franchise.phoneNumber != null && franchise.phoneNumber.toLowerCase().indexOf(filter) >= 0)
         ));
   }


   const onFranchiseDelete = (id) => {
      franchiseService.deleteFranchise(id)
      .then(
         (response) => {
            setFranchises(franchisesRef.current.filter(franchise => franchise.franchiseId !== id));
            setFilteredFranchises(filteredFranchisesRef.current.filter(franchise => franchise.franchiseId !== id));
         },
         (error) => {
            console.log(error);
         }
      )
   }

   const addBox = () => {
        history.push('/franchiseEdit/0');
   }

   return (
      <>
         <div className="w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4 top-adjustment custom-border-main">
               <div className="flex w-full trip_header ml-2">
                  <div className="col-6 text-left">
                     <img src={trip_home_icon} alt="home" />
                     <span className="font-bold"> <Link to='/' className="non-undeline-link">HJEM &nbsp; &nbsp; / &nbsp; </Link></span>
                     <span className="font-bold uppercase"> Franchiser &nbsp; &nbsp; / &nbsp; </span>
                  </div>
                  <div className="col-6 text-right" style={{display: "inline-flex"}}>

                     <input type="search" placeholder="Søk"  onChange={handleSearch} className="pl-10 pr-5 appearance-none h-10 w-full rounded-full text-sm focus:outline-none simple_sorter_btn_search" />
                     <button type="submit" className="absolute top-0 mt-3 left-0 ml-4 top-adjust" ref={searchIcon} style={{top:"-6px"}}>
                           <FiSearch className="stroke-current h-4 w-4" />
                     </button>
                     <button hidden={role != 1}  type="button" className="add_btn" ref={addBtns} id="addBtn" onClick={() => addBox()}> legg til </button>
                  </div>
               </div>
               <Section>
                  <Franchises franchises={filteredFranchises} onFranchiseDelete={onFranchiseDelete} />
               </Section>

         </div>
      </>
    )
}
export default Index
